import styled from 'styled-components';

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 10px 0;
  margin-top: 20px;
  gap: 5px;
`;

const commonButtonStyles = `
  background: none;
  border: none;
  color: #666;
  cursor: pointer;
  padding: 5px 10px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.2s ease;

  &:hover:not(:disabled),
  &:active {
    background-color: #f1f1f1;
  }

  &:disabled {
    color: #ccc;
    cursor: not-allowed;
  }
`;

export const PageButton = styled.button<{ active?: boolean }>`
  ${commonButtonStyles}
  border-radius: 50%;
  width: 30px;
  height: 30px;
  font-weight: ${props => props.active ? 'bold' : 'normal'};
  color: ${props => props.active ? '#000' : '#666'};
  ${props => props.active && `
    background-color: #f1f1f1;
  `}
`;

export const PageSelectWrapper = styled.div`
  position: relative;
  margin-left: 10px;
`;

export const PageSelect = styled.select`
  ${commonButtonStyles}
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  padding-right: 25px;
  width: auto;
  border-radius: 4px;
  
  &::-ms-expand {
    display: none;
  }
`;

export const SelectArrow = styled.div`
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid #666;
  pointer-events: none;
`;

export const EllipsisSpan = styled.span`
  margin: 0 5px;
  color: #666;
`;
